import { IPuzzle, CellState } from 'js/crossword/types';

type CellData = [string, CellState];

export interface IPuzzleSaveData {
  currentCellId: string;
  currentClueId: string;
  cells: CellData[];
  autocheck: boolean;
  time: number;
  wrap: boolean;
  rebus: boolean;
  fillRate: number;
  completed: boolean;
}

export const saveData = (puzzle: IPuzzle) => {
  try {
    localStorage.setItem(puzzle.id, JSON.stringify(getSaveData(puzzle)));
  } catch (e) {
    console.warn(e);
  }
};

export const loadData = (puzzle: IPuzzle): void => {
  try {
    const data = localStorage.getItem(puzzle.id);
    if (!data) return;
    const parsed = JSON.parse(data);
    applySaveData(puzzle, parsed);
  } catch (e) {
    console.warn(e);
  }
};

export const getLoadData = (puzzleId: string): IPuzzleSaveData | null => {
  try {
    const data = localStorage.getItem(puzzleId);
    if (!data) return null;
    const parsed = JSON.parse(data);
    return parsed;
  } catch (e) {
    console.warn(e);
    return null;
  }
}

export const hasLoadData = (puzzle: IPuzzle): boolean => {
  try {
    return Boolean(localStorage.getItem(puzzle.id))
  } catch (e) {
    console.warn(e);
    return false;
  }
}

export function getSaveData(puzzle: IPuzzle): IPuzzleSaveData {
  return {
    currentCellId: puzzle.currentCellId,
    currentClueId: puzzle.currentClueId,
    cells: puzzle.cells.map((cell) => [cell.letter, cell.state]),
    autocheck: puzzle.autocheck,
    time: puzzle.time,
    wrap: puzzle.wrap,
    rebus: puzzle.rebus,
    fillRate: puzzle.fillRate,
    completed: puzzle.completed,
  };
}

export function applySaveData(puzzle: IPuzzle, saveData: IPuzzleSaveData): void {
  puzzle.currentCellId = saveData.currentCellId;
  puzzle.currentClueId = saveData.currentClueId;
  puzzle.autocheck = saveData.autocheck;
  puzzle.time = saveData.time;
  puzzle.wrap = saveData.wrap;
  puzzle.rebus = saveData.rebus;
  puzzle.fillRate = puzzle.fillRate;
  puzzle.completed = saveData.completed ?? false,
  puzzle.cells.forEach((cell, index) => {
    const [ letter, state ] = saveData.cells[index];
    cell.letter = letter;
    cell.state = state;
  });
}
